var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.item.style),attrs:{"title":_vm.item.values}},[_c('span',{class:_vm.item.class},[_vm._v("\n    "+_vm._s(_vm.item.values || '-')+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }